export type Environment = 'SANDBOX' | 'PRODUCTION'

export const environments: Environment[] = ['PRODUCTION', 'SANDBOX']

export const environmentDescription = (environment: Environment) => {
  switch (environment) {
    case 'PRODUCTION':
      return 'Production'
    case 'SANDBOX':
      return 'Sandbox'
  }
}
